module.exports = __webpack_public_path__ + "static/img/9.95bee6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/9.png
// module id = wKja
// module chunks = 0